import React, { useEffect, useState } from 'react';
import './modal.css';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { TextButton } from '../text-button';
import { Icon } from '../icon';
const Modal = props => {
    const {
        children,
        onClick,
        buttonIsDisabled,
        modalFooterHidden,
        translation,
        ariaLabel,
        muteButton,
        onMute,
        isMuted,
    } = props;

    const [modalVisible, setModalVisible] = useState(false);

    useEffect(() => setModalVisible(true), []);

    const modalClasses = classNames({
        modal: true,
        'modal--hidden': !modalVisible && translation === true,
        'modal--footer-hidden': modalFooterHidden,
    });

    return (
        <>
            <div
                role={ariaLabel === 'welcome letter' ? null : 'dialog'}
                aria-label={ariaLabel}
                tabIndex={0}
                className={modalClasses}
                // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
            >
                {muteButton === true && (
                    <button
                        aria-label="mute audio"
                        className="modal__header-button modal__mute-audio"
                        onClick={onMute}
                        disabled={buttonIsDisabled}
                    >
                        <Icon
                            size="x-small"
                            iconName={isMuted ? 'audio-off' : 'audio-on'}
                            colorScheme="dark"
                            altText=""
                        />
                    </button>
                )}
                {ariaLabel !== 'progress update modal' && (
                    <button
                        aria-label="close modal"
                        className="modal__header-button modal__close"
                        onClick={onClick}
                        disabled={buttonIsDisabled}
                    >
                        <Icon
                            size="x-small"
                            iconName="cross"
                            colorScheme="dark"
                            altText=""
                        />
                    </button>
                )}
                {children}
            </div>
            {!modalFooterHidden && (
                <div className="modal__footer">
                    <TextButton
                        onClick={onClick}
                        text="Continue"
                        isDisabled={buttonIsDisabled}
                    />
                </div>
            )}
        </>
    );
};
Modal.defaultProps = {
    modalFooterHidden: false,
    translation: true,
};

Modal.propTypes = {
    onClick: PropTypes.func,
    modalFooterHidden: PropTypes.bool,
    translation: PropTypes.bool,
    arialLabel: PropTypes.string,
    muteButton: PropTypes.bool,
    isMuted: PropTypes.bool,
    onMute: PropTypes.func,
};

export { Modal };
